import { getProviderProfileOptions } from '../../../../../../api'
import { EMPTY_LIST } from '../../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../../utils/api'
import { FieldStackedLabel } from '../../../../../Field'
import { FormFieldSelectNG } from '../../../../../Form'
import { FormikField } from '../../../../../Formik'
import { getAsyncSelectShowSelectedApiParamIdPK } from '../../../../../Select'
import { UserMultiSelect } from '../../../../../User'
import { toSelectListItems } from '../../../../RequestEditProviderModal'

import * as styles from '../../../ConnectedRequestsMassEditModal.module.css'

import ProviderIcon from '../../../../../../icons/provider.svg'

function ProvidersValueField({ label, name, placeholder }) {
  return (
    <FormikField
      multi
      Component={FormFieldSelectNG}
      EntityIcon={ProviderIcon}
      Field={FieldStackedLabel}
      Select={UserMultiSelect}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder,
          },
        },
      }}
      emptyValue={EMPTY_LIST}
      fieldComponentProps={{
        className: styles.valueFieldStackedLabel,
        label,
      }}
      getData={getProviderProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getShowSelectedApiParam={getAsyncSelectShowSelectedApiParamIdPK}
      name={name}
      toPreparedItems={toSelectListItems}
    />
  )
}

export default ProvidersValueField
